import { render } from "./ActionAlert.vue?vue&type=template&id=540bfd82&scoped=true"
import script from "./ActionAlert.vue?vue&type=script&lang=js"
export * from "./ActionAlert.vue?vue&type=script&lang=js"

import "./ActionAlert.vue?vue&type=style&index=0&id=540bfd82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540bfd82"]])

export default __exports__